// tslint:disable: cyclomatic-complexity
import Styled, { css } from 'styled-components';

import { cssDeclaration } from '../../Utils';
import { IFocusControl, IHoveredProps, IInputError } from '../common';

type StyledTextArea = IInputError & IFocusControl & IHoveredProps;

export const StyledTextArea = Styled.textarea<StyledTextArea>`
  width: 100%;

  ${({ theme: { themeTwo }, error, isHovered, clickFocus }) => {
    const { form: { textarea }} = themeTwo;
    const { state: { hover, focus, disabled, error: errorState }} = textarea;

    return css`
      display: block;
      outline: none;

      /* color */ ${textarea.font && cssDeclaration(themeTwo, 'color', textarea.font.color)};
      /* font-size */ ${textarea.font && textarea.font.size && cssDeclaration(themeTwo, 'font-size', textarea.font.size)}
      /* line-height */ ${textarea.font && textarea.font.lineHeight && cssDeclaration(themeTwo, 'line-height', textarea.font.lineHeight)}
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', textarea.backgroundColor)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', textarea.padding)};
      /* border */ ${cssDeclaration(themeTwo, 'border', textarea.border)};
      /* border-radius */ ${cssDeclaration(themeTwo, 'border-radius', textarea.round)};

      ${isHovered && css`
        ${hover.font && cssDeclaration(themeTwo, 'color', hover.font.color)};
        ${hover.border && cssDeclaration(themeTwo, 'border', hover.border)};
        ${hover.shadow && cssDeclaration(themeTwo, 'box-shadow', hover.shadow)};
      `}

      ${!clickFocus && css`
        &:focus {
          /* color */ ${focus.font && cssDeclaration(themeTwo, 'color', focus.font.color)};
          /* border */ ${focus.border && cssDeclaration(themeTwo, 'border', focus.border)};
          /* box-shadow */ ${focus.shadow && cssDeclaration(themeTwo, 'box-shadow', focus.shadow)};
          /* outline */ ${focus.outline && cssDeclaration(themeTwo, 'outline', focus.outline)};
        }
      `}

      &:disabled {
        cursor: not-allowed;
        /* color */ ${disabled.font && cssDeclaration(themeTwo, 'color', disabled.font.color)};
        /* background-color */ ${disabled.backgroundColor && cssDeclaration(themeTwo, 'background-color', disabled.backgroundColor)};
        /* border */ ${disabled.border && cssDeclaration(themeTwo, 'border', disabled.border)};
        /* box-shadow */ ${disabled.shadow && cssDeclaration(themeTwo, 'box-shadow', disabled.shadow)};
        /* placeholder */ ${disabled.placeholder && cssDeclaration(themeTwo, 'placeholder', disabled.placeholder)};
      }

      ${error && css`
        /* color */ ${errorState.font && cssDeclaration(themeTwo, 'color', errorState.font.color)};
        /* border */ ${errorState.border && cssDeclaration(themeTwo, 'border', errorState.border)};
        /* box-shadow */ ${errorState.shadow && cssDeclaration(themeTwo, 'box-shadow', errorState.shadow)};
      `}
    `;
  }}
`;
